/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Save_TitleInputs */



/**
* | output |
* | --- |
* | "Restore Event Groups" |
*
* @param {Automatic_Save_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_save_title = /** @type {((inputs?: Automatic_Save_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Save_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Restaurer les groupes d’événements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignisgruppen wiederherstellen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ripristina gruppi di eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Восстановить группы событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Restaurar grupos de eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("恢复事件组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントグループを復元する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट समूहों को पुनर्स्थापित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Restaurar grupos de eventos")
	return /** @type {LocalizedString} */ ("Restore Event Groups")
});